import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { isValidRecipient, RecipientChannel } from '../model/alerting'

interface IRecipientFieldProps {
  channel: RecipientChannel
  action?: JSX.Element
  onAdd: (value: string) => void
}

/** Поле канала с кнопкой ADD: добавляет только значение, прошедшее проверку формата */
export const RecipientField = ({ channel, action, onAdd }: IRecipientFieldProps) => {
  const { t } = useTranslation()
  const [value, setValue] = useState('')
  const trimmed = value.trim()
  const valid = isValidRecipient(channel, trimmed)

  const add = () => {
    if (!valid) return

    // почта и @username к регистру нечувствительны, числовой chat id lowercase не меняет
    onAdd(trimmed.toLowerCase())
    setValue('')
  }

  return (
    <div className={'flex items-end gap-[8px]'}>
      <div className={'min-w-0 flex-1'}>
        <BpInput
          placeholder={t(
            channel === 'email'
              ? 'pages.project.placeholders.enterEmail'
              : 'pages.project.placeholders.insertChatId',
          )}
          action={action}
          label={t(channel === 'email' ? 'fields.email' : 'fields.telegramChatId')}
          value={value}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              add()
            }
          }}
          onChange={(e) => setValue(e.target.value)}
          onClear={() => setValue('')}
        />
      </div>
      <div className={'mb-[2px]'}>
        <BpButton className={'uppercase'} disabled={!valid} type={'button'} onClick={add}>
          {t('buttons.add')}
        </BpButton>
      </div>
    </div>
  )
}
